import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Icon, Link } from '@amzn/awsui-components-react-v3';

import { ValueWithLabel } from 'src/components/Utils';

import { AsyncState, Model } from '../../../store/types';
import CopyText from '../../CopyText';
import { ExecutionStatus } from '../../ExecutionStatus/ExecutionStatus';

interface MPNCellProps {
  model: Model;
}

export const MPNIPNDefinitionCell = ({ model }: { model: Model }) => {
  return (
    <Box variant="span" padding={{ right: 's', left: 's' }}>
      <CopyText label="MPN" value={model?.expectedMPN || ''}>
        {model?.expectedMPN}{' '}
      </CopyText>
    </Box>
  );
};

export const MPNIPNDefinition = ({ model }: { model: Model }) => {
  return (
    <ValueWithLabel label="Manufactured part number (MPN)">
      <MPNIPNDefinitionCell model={model} />
    </ValueWithLabel>
  );
};

export const APNCellDefinition = ({ ipn }: { ipn: string }) => {
  return (
    <ValueWithLabel label="Amazon part number (APN/IPN)">
      <CopyText label="APN/IPN" value={ipn || ''}>
        {ipn}
      </CopyText>
    </ValueWithLabel>
  );
};

export const MPNCell = ({ model }: MPNCellProps) => {
  let history = useHistory();
  let { referenceId, receiveType } = useParams();

  const onHandleClickModel = () => {
    history.push(`/receive/${receiveType}/${referenceId}/model/${model?.mpnIpnId}`);
  };

  return (
    <Box>
      <CopyText label="MPN" value={model?.expectedMPN || ''}>
        <Link onFollow={onHandleClickModel} ariaLabel={`expected-mpn-link-${model?.expectedMPN}`}>
          {model?.warning && <Icon name="status-warning" />} {model?.expectedMPN}
        </Link>
      </CopyText>

      {model?.receiveExecutionUUId && (
        <Box margin={{ left: 's' }}>
          <ExecutionStatus
            model={model}
            refetch={model?.status !== AsyncState.OK && model?.status !== AsyncState.ERROR}
          />
        </Box>
      )}
    </Box>
  );
};
